import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

const baseUrl = (projectId) => `${API_HOST}/api/story-structure/projects/${projectId}`;

export const fetchStoryStructureState = (projectId) => {
  return authenticatedFetch(baseUrl(projectId));
};

export const saveStoryStructureState = (projectId, state) => {
  return authenticatedFetch(baseUrl(projectId), {
    method: 'POST',
    body: JSON.stringify(state),
  });
};

export const generateStoryStructureCards = (projectId, payload) => {
  return authenticatedFetch(`${baseUrl(projectId)}/cards/generate`, {
    method: 'POST',
    body: JSON.stringify(payload),
    timeout: 30 * 60 * 1000,
  });
};

export const buildStoryStructureGenerationPackage = (projectId, state) => {
  return authenticatedFetch(`${baseUrl(projectId)}/generation-package`, {
    method: 'POST',
    body: JSON.stringify(state || {}),
  });
};
